<template>
  <div v-loading="loading" class="newBox">
    <div v-show="!loading&&isWxBind">
      <p class="noUse">
        该微信已经绑定
      </p>
    </div>
    <div v-show="!loading&&isout">
      <p class="noUse">
        <!--登录信息过期失效请 <a href="/login" style="color: #ed4040;font-size: 18px">3s后返回</a>-->
      </p>
    </div>
    <div v-show="!loading&&isSuccess">
      <p class="noUse">
        <!--<span style="color: green;font-size: 18px">换绑微信成功3s后返回</span>-->
      </p>
    </div>
  </div>
</template>

<script>
import { phoneBindingCallback } from '@/api/api.js'
export default {
  head() {
    return {
      title: '彭祖世家网Pengzushijia.com',
      mateDesc: '《彭祖世家总谱-事典》门户网站Pengzushijia.COM ，系彭祖世家文化发展有限公司与武汉聚脉网络科技有限公司合作，基于聚脉网络旗下国家发明专利技术产品“大谱师-互联网家谱协作编纂平台”进行品牌定制，专属服务全球彭氏族群编纂《彭祖世家总谱-事典》总谱、家族谱、家庭谱的互联网家谱协作编纂平台。',
      keys: '彭祖,彭城,彭氏,彭姓,彭氏家谱,彭氏宗谱,彭氏族谱,彭祖世家,彭氏修谱,门户网站'
    }
  },
  data() {
    return {
      loading: true,
      isWxBind: false,
      isout: false,
      isSuccess: false
    }
  },
  mounted() {
    if (this.$route.query.code) {
      var obj = this.$route.query
      obj.phone = this.getLoca('loginphone')
      obj.password = this.getLoca('pwregister')
      phoneBindingCallback(obj).then(res => {
        if (res.data.code == 0) {
          this.loading = false
          this.setloca('userid', res.data.fwUserId, 7200)
          this.setloca('readerUsrId', res.data.readerUsrId, 7200)
          this.$message({
            type: 'success',
            message: '注册成功'
          })
          this.$router.push({ path: '/user?index=0' })
        }
        if (res.data.code == 1) {
          this.loading = false
          this.isout = true
          this.$message({
            type: 'error',
            message: '注册失败稍后重试'
          })
          window.close()
        }
        if (res.data.code == 2) {
          this.loading = false
          this.isWxBind = true
        }
      })
    }
  },
  methods: {

  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .noUse{
        margin-top: 20px;
        text-align: center;
        font-size: 18px;
    }
    .newBox{
        width: 100%;
        position: absolute;
        background-color: #B2B2B2;
        height: 100vh;
        top: 0;
        left: 0;
        z-index: 999;
        .loginboxs{
            height: 600px;
            width: 340px;
            background-color: #fff;
            text-align: center;
            padding: 0 80px;
            margin: 50px auto;
            position: relative;
            .denglubtn{
                width: 100%;
                background-color: #69513c;
                border-color: #69513c;
                margin-top: 20px;
            }
            .checkbox{
                width: 230px;
            }
            .getVcodeBtn{
                width: 100px;
                display: inline-block;
                background-color: #ed4040;
                margin-left: 10px;
                border-radius: 5px;
                text-align: center;
                color: #ffffff;
                font-size: 12px;
                cursor: pointer;
            }
            .num{
                background-color: #fff;
                color: #a19d9e;
                cursor: not-allowed;
                span{
                    font-size: 12px;
                    color: #a19d9e;
                }
            }
        }
    }
</style>
<!--手机端样式-->

